export const MODELS_PER_PAGE = 18;
